<template>
  <div>
    <router-view v-if="isOrgAdmin" />
    <empty-page v-else type="permission"></empty-page>
  </div>
</template>

<script>
import EmptyPage from '@/shared/components/EmptyPage.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    EmptyPage,
  },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
};
</script>
